import React from "react";
import "./FlightDetailsHeader.css";

export default function FlightDetailsHeader({ search, onBack }) {
  const subtitle = search
    ? `${search.originCity} → ${search.destinationCity} · ${search.tripTypeLabel} · ${search.passengersLabel}`
    : "";

  return (
    <header className="fe2-dhead">
      <div className="fe2-dhead__text">
        <h1 className="fe2-dhead__title">פרטי הטיסה</h1>
        {subtitle ? <p className="fe2-dhead__subtitle">{subtitle}</p> : null}
      </div>
      <button type="button" className="fe2-dhead__back" onClick={onBack}>
        ← חזרה לתוצאות
      </button>
    </header>
  );
}
